import React, { useEffect, useState } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Box, Button, DrawerBody, DrawerFooter, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import FormInput from '../../../../components/form/FormInput';
import InputLabel from '../../../../components/form/InputLabel';
import { updateInsuranceRequirement } from '../../../../redux/modules/insuranceRequirements';
import { hideTray, updateTrayProps } from '../../../../redux/modules/tray';
import { jobDetailsSearch } from '../../../../redux/reducer';
import { pruneObject } from '../../../../utils/objectUtil';

import { fieldNames, requirementFormStack } from './util';

const RequirementInfoTray = ({ requirement, onFormSubmit }) => {
  const dispatch = useDispatch();
  const [isSubmitting, setSubmitting] = useState(false);

  const useFormMethods = useForm({
    defaultValues: {
      [fieldNames.contractNumber]: requirement.contractNumber,
      [fieldNames.contactEmail]: requirement.requirementEmail,
      [fieldNames.description]: requirement.requirementDescription
    }
  });

  const { handleSubmit, control } = useFormMethods;

  const { isDirty } = useFormState({ control });

  useEffect(() => {
    dispatch(updateTrayProps({ formIsDirty: isDirty }));
  }, [isDirty]);

  const onSubmit = async data => {
    setSubmitting(true);
    const requirementData = pruneObject(data);

    await onFormSubmit(requirement, requirementData);

    setSubmitting(false);
    dispatch(hideTray());
  };

  // TODO: add attachments section
  return (
    <>
      <DrawerBody>
        <Box height="87px">
          <InputLabel labelName="Insured Name" />
          <Flex alignItems="center" height="40px" pl="16px">
            <Text color="greyScale.900" textStyle="bodyMd500">{requirement.companyName}</Text>
          </Flex>
        </Box>
        <Box height="87px">
          <InputLabel labelName="Insured Contact Email" />
          <Flex alignItems="center" height="40px" pl="16px">
            <Text color="greyScale.900" textStyle="bodyMd500">{requirement.email}</Text>
          </Flex>
        </Box>
        <Box height="87px">
          <InputLabel labelName="Insured Contact CCs" />
          <Flex alignItems="center" height="40px" pl="16px">
            <Text color="greyScale.900" textStyle="bodyMd500">{requirement?.cc || '-'}</Text>
          </Flex>
        </Box>
        <form id="updateRequirementInformation" onSubmit={handleSubmit(onSubmit)}>
          {requirementFormStack.map(input => (
            <FormInput
              inputName={input.name}
              isDisabled={isSubmitting}
              key={input.name}
              labelName={input.label}
              placeholder={input.placeholder}
              required={input.required}
              toolTip={input?.tooltip}
              type={input?.type}
              useFormMethods={useFormMethods}
              validationRules={input.validation}
            />
          ))}
        </form>
      </DrawerBody>
      <DrawerFooter>
        <Button form="updateRequirementInformation" isLoading={isSubmitting} type="submit" width="100%">Save</Button>
      </DrawerFooter>
    </>
  );
};

RequirementInfoTray.propTypes = {
  requirement: PropTypes.shape({
    requirementId: PropTypes.number,
    companyName: PropTypes.string,
    email: PropTypes.string,
    cc: PropTypes.string,
    contractNumber: PropTypes.string,
    requirementEmail: PropTypes.string,
    requirementCc: PropTypes.string,
    requirementDescription: PropTypes.string
  })
};

export default RequirementInfoTray;
